import React from 'react';
import './PhotoCollage.css';

import image1 from '../Images/Profile_Picture1.jpeg';
import image2 from '../Images/Profile_Picture2.jpeg';
import image3 from '../Images/Profile_Picture3.jpeg';

export function PhotoCollage() {
  return (
    <div className="photo-collage">
      <img
        src={image1}
        alt="Aidan portrait 1"
        className="collage-image collage-image-1"
        loading="lazy"
        decoding="async"
      />
      <img
        src={image2}
        alt="Aidan portrait 2"
        className="collage-image collage-image-2"
        loading="lazy"
        decoding="async"
      />
      <img
        src={image3}
        alt="Aidan portrait 3"
        className="collage-image collage-image-3"
        loading="lazy"
        decoding="async"
      />
    </div>
  );
}
